module.exports = require("@graphistry/falcor-path-utils/lib/support/materializedAtom");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/support/materializedAtom"
// module id = 33
// module chunks = 0